import { Icon } from '@sendible/design-system/src';
import { ChangeBadge, ChangeRow, ChangeText } from './index.styles';

const ChangeComponent = ({ isPositive, formattedDiff, formattedPct }: { isPositive: boolean; formattedDiff: string; formattedPct: string }) => {
  return (
    <ChangeRow $positive={isPositive}>
      <ChangeBadge $positive={isPositive}>
        <Icon
          color="brandLight"
          name={isPositive ? 'arrow_up_right' : 'arrow_down_left'}
        />
      </ChangeBadge>
      <ChangeText>
        {formattedDiff} ({formattedPct})
      </ChangeText>
    </ChangeRow>
  );
};

export default ChangeComponent;
